import React from 'react';
import { useDispatch } from "react-redux";

import ReactWebChat from './WebChat';


const App = () => {
	const dispatch = useDispatch();
	return (
      <div id="app">
		<ReactWebChat appDispatch={ dispatch } />
      </div>
	);
};

export default App;
